<div class="board-wrapper">
  <div class="kanban-board">
    <div class="kanban-column" *ngFor="let col of columns; trackBy: trackByColId"
      [ngClass]="[col.cls, dragOverCol === col.id ? 'drag-over' : '']" (dragover)="onDragOver($event, col.id)"
      (dragleave)="onDragLeave($event)" (drop)="onDrop($event, col.id)">
      <div class="column-header">
        <div class="header-left">
          <i [class]="col.icon + ' col-icon'"></i>
          <span class="col-title">{{ col.title }}</span>
          <span class="count-badge">{{ getCards(col.id).length }}</span>
        </div>
        <button *ngIf="col.id === 'todo'" class="add-col-btn" (click)="addWorkOrder(Operation)">
          <i class="ri-add-line"></i> Add
        </button>
      </div>
      <div class="column-body">
        <div *ngFor="let card of getCards(col.id); trackBy: trackByCardId" class="wo-card" [attr.id]="card.cardId"
          [ngClass]="'status-' + statusClass(card.status)" draggable="true" (dragstart)="onDragStart($event, card)"
          (dragend)="onDragEnd($event)">
          <div class="card-header">
            <span class="status-badge" [ngClass]="badgeClass(card.status)">
              <i [class]="statusIcon(card.status)"></i>
              {{ card.status }}
            </span>
            <div class="card-actions">
              <i class="ri-edit-line action-icon" *ngIf="card.col === 'todo' || card.col === 'planning'"
                title="Edit Work Order" (click)="editWorkOrder(card, Operation)"></i>
              <i class="ri-add-circle-line action-icon" *ngIf="card.col === 'production' || card.col === 'onhold'"
                title="Add Batch" (click)="editWorkOrder(card, Operation)"></i>
              <i class="ri-forbid-line action-icon action-icon--abort" *ngIf="canAbort(card)" title="Abort Work Order"
                (click)="confirmAbortCard(card)"></i>
              <i class="ri-delete-bin-line action-icon action-icon--delete" *ngIf="card.col === 'todo'"
                title="Delete Work Order" (click)="confirmDeleteCard(card)"></i>
              <i class="ri-more-2-fill menu-icon"></i>
            </div>
          </div>
          <div class="card-row">
            <i class="ri-file-list-2-line row-icon"></i>
            <span class="row-label">{{ card.orderNumber }}</span>
          </div>
          <div class="card-row">
            <i class="ri-tools-line row-icon"></i>
            <span class="row-label">{{ card.jobName }}</span>
          </div>
          <div class="card-row">
            <i class="ri-stack-line row-icon"></i>
            <span class="row-label">Qty: {{ card.requiredQty | number }}</span>
          </div>
          <div class="card-row" *ngIf="card.batches?.length">
            <i class="ri-layers-line row-icon"></i>
            <span class="row-label">
              {{ card.batches.length }} Batch{{ card.batches.length > 1 ? 'es' : '' }}
            </span>
          </div>
          <div class="card-row card-row--abort" *ngIf="card.status === 'Aborted' && card.abortReason">
            <i class="ri-chat-quote-line row-icon row-icon--abort"></i>
            <span class="row-label row-label--abort" [title]="card.abortReason">{{ card.abortReason }}</span>
          </div>
        </div>
        <div class="empty-state" *ngIf="getCards(col.id).length === 0">
          <i class="ri-file-list-3-line empty-icon"></i>
          <p>No Work Orders</p>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-overlay" *ngIf="showConfirmModal" (click)="cancelMove()">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <i class="ri-arrow-right-line modal-icon"></i>
        <h4>Move Work Order?</h4>
      </div>
      <p class="modal-body" *ngIf="pendingMove && pendingCard">
        Move <strong>{{ pendingCard.jobName }}</strong> from
        <strong>{{ getColumnLabel(pendingMove.fromCol) }}</strong> to
        <strong>{{ getColumnLabel(pendingMove.toCol) }}</strong>?
      </p>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="cancelMove()">Cancel</button>
        <button class="btn-confirm" (click)="confirmMove()">Confirm</button>
      </div>
    </div>
  </div>
  <div class="modal-overlay" *ngIf="showDeleteModal" (click)="cancelDelete()">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <i class="ri-delete-bin-line modal-icon modal-icon--danger"></i>
        <h4>Delete Work Order?</h4>
      </div>
      <p class="modal-body" *ngIf="cardToDelete">
        Are you sure you want to delete work order <strong>{{ cardToDelete.orderNumber }}</strong>
        — <strong>{{ cardToDelete.jobName }}</strong>? This action cannot be undone.
      </p>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="cancelDelete()">Cancel</button>
        <button class="btn-confirm btn-confirm--danger" (click)="executeDelete()">Delete</button>
      </div>
    </div>
  </div>
  <div class="modal-overlay" *ngIf="showAbortModal" (click)="cancelAbort()">
    <div class="confirm-modal confirm-modal--abort" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <i class="ri-forbid-line modal-icon modal-icon--abort"></i>
        <h4>Abort Work Order?</h4>
      </div>
      <div class="modal-body" *ngIf="cardToAbort">
        <p class="abort-info">
          You are about to abort work order <strong>{{ cardToAbort.orderNumber }}</strong>
          — <strong>{{ cardToAbort.jobName }}</strong>.
          This will move the order to <strong>Completed</strong> with an <strong>Aborted</strong> status.
        </p>
        <div class="abort-reason-field">
          <label class="abort-reason-label">
            Reason for Abort <span class="wo-required">*</span>
          </label>
          <textarea class="abort-reason-input" [class.abort-reason-input--error]="abortReasonError"
            [(ngModel)]="abortReason" (input)="abortReasonError = false"
            placeholder="Enter the reason for aborting this work order..." rows="3">
          </textarea>
          <span class="abort-reason-error" *ngIf="abortReasonError">
            <i class="ri-error-warning-line"></i> Abort reason is required.
          </span>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="cancelAbort()">Cancel</button>
        <button class="btn-confirm btn-confirm--abort" (click)="executeAbort()">
          <i class="ri-forbid-line"></i> Abort Work Order
        </button>
      </div>
    </div>
  </div>
  <div class="toast-msg" [ngClass]="[toastType, toastVisible ? 'visible' : '']">
    <i [class]="toastType === 'success' ? 'ri-checkbox-circle-line' : 'ri-error-warning-line'"></i>
    {{ toastMsg }}
  </div>
</div>

<ng-template #Operation let-modal>
  <div class="wo-modal-header">
    <h5>{{ isEditMode ? (editingCard?.col === 'todo' || editingCard?.col==='planning' ? 'Edit Work Order' : 'Add Batch')
      : 'New Work Order' }}</h5>
    <button class="wo-close-btn" (click)="modal.dismiss()"><i class="ri-close-line"></i></button>
  </div>
  <div class="wo-modal-body">
    <form [formGroup]="workOrderForm">
      <div class="wo-section-title">Order Details</div>
      <div class="wo-row">
        <div class="wo-field">
          <label>Order Number <span class="wo-required">*</span></label>
          <input type="text" class="wo-input"
            [class.wo-input-error]="!isEditMode && (submitted || orderNumberCtrl.touched) && orderNumberCtrl.invalid"
            [class.wo-input-readonly]="isEditMode" formControlName="orderNumber" [readonly]="isEditMode"
            placeholder="e.g. WO010">
          <span class="wo-field-error"
            *ngIf="!isEditMode && (submitted || orderNumberCtrl.touched) && orderNumberCtrl.invalid">
            <i class="ri-error-warning-line"></i> Order number is required.
          </span>
        </div>
        <div class="wo-field">
          <label>Job Name <span class="wo-required">*</span></label>
          <select class="wo-input" [class.wo-input-error]="(submitted || jobNameCtrl.touched) && jobNameCtrl.invalid"
            [class.wo-input-readonly]="isEditMode && editingCard?.col !== 'todo' && editingCard?.col !== 'planning'"
            formControlName="jobName"
            [attr.disabled]="(isEditMode && editingCard?.col !== 'todo' && editingCard?.col !== 'planning') ? true : null"
            (change)="onJobChange($any($event.target).value)">
            <option value="">— Select Job —</option>
            <option *ngFor="let job of jobMasterList; trackBy: trackByIndex" [value]="job.jobName">
              {{ job.jobName }}
            </option>
          </select>
          <span class="wo-field-error" *ngIf="(submitted || jobNameCtrl.touched) && jobNameCtrl.invalid">
            <i class="ri-error-warning-line"></i> Job name is required.
          </span>
        </div>
        <div class="wo-field">
          <label>Required Qty <span class="wo-required">*</span></label>
          <input type="number" class="wo-input"
            [class.wo-input-error]="(submitted || requiredQtyCtrl.touched) && requiredQtyCtrl.invalid"
            [class.wo-input-readonly]="isEditMode && editingCard?.col !== 'todo' && editingCard?.col !== 'planning'"
            formControlName="requiredQty"
            [readonly]="isEditMode && editingCard?.col !== 'todo' && editingCard?.col !== 'planning'" placeholder="0">
          <span class="wo-field-error" *ngIf="(submitted || requiredQtyCtrl.touched) && requiredQtyCtrl.invalid">
            <i class="ri-error-warning-line"></i> Required qty must be at least 1.
          </span>
        </div>
      </div>
      <div class="wo-row">
        <div class="wo-field">
          <label>Planned Start Time <span class="wo-required">*</span></label>
          <input type="datetime-local" class="wo-input"
            [class.wo-input-error]="(submitted || plannedStartCtrl.touched) && plannedStartCtrl.invalid"
            [class.wo-input-readonly]="(isEditMode && editingCard?.col !== 'todo' && editingCard?.col !== 'planning') || isPlannedTimeLockedByJob()"
            formControlName="plannedStartTime"
            [attr.readonly]="(isEditMode && editingCard?.col !== 'todo' && editingCard?.col !== 'planning') ? true : null"
            [attr.disabled]="isPlannedTimeLockedByJob() ? true : null" [attr.min]="getMinWorkOrderStartTime()"
            (change)="onWorkOrderTimeChange()">
          <span class="wo-field-hint wo-field-hint--warn"
            *ngIf="isEditMode && editingCard?.col === 'todo' && isPlannedTimeLockedByJob()">
            <i class="ri-lock-line"></i> Select a Job Name to enable planned times.
          </span>
          <span class="wo-field-error" *ngIf="(submitted || plannedStartCtrl.touched) && plannedStartCtrl.invalid">
            <i class="ri-error-warning-line"></i> Planned start time is required.
          </span>
        </div>
        <div class="wo-field">
          <label>Planned End Time <span class="wo-required">*</span></label>
          <input type="datetime-local" class="wo-input"
            [class.wo-input-error]="(submitted || plannedEndCtrl.touched) && plannedEndCtrl.invalid"
            [class.wo-input-readonly]="(isEditMode && editingCard?.col !== 'todo' && editingCard?.col !== 'planning') || isPlannedTimeLockedByJob()"
            formControlName="plannedEndTime"
            [attr.readonly]="(isEditMode && editingCard?.col !== 'todo' && editingCard?.col !== 'planning') ? true : null"
            [attr.disabled]="isPlannedTimeLockedByJob() ? true : null"
            [attr.min]="plannedStartCtrl.value || getMinWorkOrderStartTime()" (change)="onWorkOrderTimeChange()">
          <span class="wo-field-error" *ngIf="(submitted || plannedEndCtrl.touched) && plannedEndCtrl.invalid">
            <i class="ri-error-warning-line"></i> Planned end time is required.
          </span>
        </div>
      </div>
      <div class="wo-divider"></div>
      <div class="wo-batches-header">
        <div class="wo-section-title" style="margin-bottom:0">Batches</div>
      </div>
      <div formArrayName="batches">
        <div *ngFor="let batch of batches.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i"
          class="wo-batch-card" [class.wo-batch-card--locked]="isExistingBatch(i)">
          <div class="wo-batch-header">
            <span class="wo-batch-title">
              <i class="ri-layers-line"></i> Batch {{ i + 1 }}
              <span class="wo-batch-locked-badge" *ngIf="isExistingBatch(i)">
                <i class="ri-lock-line"></i> Existing
              </span>
            </span>
            <button type="button" class="wo-remove-btn" *ngIf="batches.length > 1 && !isExistingBatch(i)"
              (click)="removeBatch(i)">
              <i class="ri-delete-bin-line"></i>
            </button>
          </div>
          <div class="wo-row">
            <div class="wo-field">
              <label>Batch Start Time</label>
              <input type="text" class="wo-input wo-input-readonly" formControlName="batchStartTime" readonly
                placeholder="Auto-filled from processes">
            </div>
            <div class="wo-field">
              <label>Batch End Time</label>
              <input type="text" class="wo-input wo-input-readonly" formControlName="batchEndTime" readonly
                placeholder="Auto-filled from processes">
            </div>
          </div>
          <div class="wo-no-job-warn" *ngIf="!jobNameCtrl.value && !isExistingBatch(i)">
            <i class="ri-information-line"></i> Select a Job Name above to enable process selection.
          </div>
          <div class="wo-info-warn" *ngIf="jobNameCtrl.value && !isWorkOrderTimesSet() && !isExistingBatch(i)">
            <i class="ri-time-line"></i> Set valid planned start and end times to enable process time fields.
          </div>
          <div class="wo-process-header">
            <span class="wo-sub-title">Processes</span>
            <button type="button" class="wo-add-btn wo-add-btn--sm" *ngIf="!isExistingBatch(i)"
              (click)="addMachineRow(i)">
              <i class="ri-add-line"></i> Add Process
            </button>
          </div>
          <div formArrayName="machineRows">
            <div class="wo-table-head">
              <div class="wo-th" style="flex:1.3">Process <span class="wo-required" *ngIf="!isExistingBatch(i)">*</span>
              </div>
              <div class="wo-th" style="flex:1.2">Machine <span class="wo-required" *ngIf="!isExistingBatch(i)">*</span>
              </div>
              <div class="wo-th" style="flex:1.4">Process Start <span class="wo-required"
                  *ngIf="!isExistingBatch(i)">*</span></div>
              <div class="wo-th" style="flex:1.4">Process End <span class="wo-required"
                  *ngIf="!isExistingBatch(i)">*</span></div>
              <div class="wo-th" style="flex:0.9">Planned Qty <span class="wo-required"
                  *ngIf="!isExistingBatch(i)">*</span></div>
              <div class="wo-th" style="flex:0.8">Capacity</div>
              <div class="wo-th" style="flex:0 0 36px"></div>
            </div>
            <div *ngFor="let row of getMachineRows(i).controls; let j = index; trackBy: trackByIndex"
              [formGroupName]="j" class="wo-table-row-wrap">
              <div class="wo-table-row" [class.wo-table-row--locked]="isExistingBatch(i)">
                <div class="wo-td" style="flex:1.3">
                  <select class="wo-input" [class.wo-input-readonly]="isExistingBatch(i)" formControlName="processName"
                    [class.wo-input-error]="!isExistingBatch(i) && isFieldInvalid(getMachineRows(i).at(j).get('processName'))"
                    (change)="!isExistingBatch(i) && onProcessChange(i, j, $any($event.target).value)">
                    <option value="">Select</option>
                    <option *ngFor="let p of selectedJobProcesses; trackBy: trackByIndex" [value]="p.processName">
                      {{ p.processName }}
                    </option>
                  </select>
                </div>
                <div class="wo-td" style="flex:1.2">
                  <select class="wo-input" [class.wo-input-readonly]="isExistingBatch(i)"
                    [class.wo-input-error]="!isExistingBatch(i) && isFieldInvalid(getMachineRows(i).at(j).get('machine'))"
                    formControlName="machine" (change)="!isExistingBatch(i) && onMachineChange(i, j)">
                    <option value="">Select</option>
                    <option *ngFor="let m of machineData; trackBy: trackByIndex" [value]="m.deviceName">
                      {{ m.deviceName }} ({{ m.meterSupplier }})
                    </option>
                  </select>
                </div>
                <div class="wo-td" style="flex:1.4">
                  <input type="datetime-local" class="wo-input" [class.wo-input-readonly]="isExistingBatch(i)"
                    formControlName="processstartTime"
                    [class.wo-input-error]="!isExistingBatch(i) && (isFieldInvalid(getMachineRows(i).at(j).get('processstartTime')) || getTimeErrors(i,j).length > 0)"
                    [attr.disabled]="(!isWorkOrderTimesSet() || isExistingBatch(i)) ? true : null"
                    [attr.min]="getWorkOrderMin()" [attr.max]="getWorkOrderMax()" (change)="onTimeChange(i, j)">
                </div>
                <div class="wo-td" style="flex:1.4">
                  <input type="datetime-local" class="wo-input" [class.wo-input-readonly]="isExistingBatch(i)"
                    formControlName="processendTime"
                    [class.wo-input-error]="!isExistingBatch(i) && (isFieldInvalid(getMachineRows(i).at(j).get('processendTime')) || getTimeErrors(i,j).length > 0)"
                    [attr.disabled]="(!isWorkOrderTimesSet() || isExistingBatch(i)) ? true : null"
                    [attr.min]="getWorkOrderMin()" [attr.max]="getWorkOrderMax()" (change)="onTimeChange(i, j)">
                </div>
                <div class="wo-td" style="flex:0.9">
                  <input type="number" class="wo-input" [class.wo-input-readonly]="isExistingBatch(i)"
                    [class.wo-input-error]="!isExistingBatch(i) && (isFieldInvalid(getMachineRows(i).at(j).get('plannedQty')) || isQtyExceedsCapacity(i, j))"
                    formControlName="plannedQty" [readonly]="isExistingBatch(i)" placeholder="0"
                    (input)="!isExistingBatch(i) && onPlannedQtyChange(i, j)">
                </div>
                <div class="wo-td" style="flex:0.8">
                  <input type="number" class="wo-input wo-input-readonly" formControlName="capacity" readonly
                    placeholder="—">
                </div>
                <div class="wo-td wo-td--center" style="flex:0 0 36px">
                  <button type="button" class="wo-remove-btn"
                    *ngIf="getMachineRows(i).length > 1 && !isExistingBatch(i)" (click)="removeMachineRow(i, j)">
                    <i class="ri-close-line"></i>
                  </button>
                </div>
              </div>
              <div class="wo-time-errors" *ngIf="!isExistingBatch(i) &&
                       (submitted || getMachineRows(i).at(j).touched) &&
                       (getTimeErrors(i, j).length > 0 ||
                        isQtyExceedsCapacity(i, j) ||
                        isFieldInvalid(getMachineRows(i).at(j).get('machine')) ||
                        isFieldInvalid(getMachineRows(i).at(j).get('processName')) ||
                        isFieldInvalid(getMachineRows(i).at(j).get('processstartTime')) ||
                        isFieldInvalid(getMachineRows(i).at(j).get('processendTime')) ||
                        isFieldInvalid(getMachineRows(i).at(j).get('plannedQty')))">
                <span *ngIf="isFieldInvalid(getMachineRows(i).at(j).get('machine'))" class="wo-time-error">
                  <i class="ri-error-warning-line"></i> Machine is required.
                </span>
                <span *ngIf="isFieldInvalid(getMachineRows(i).at(j).get('processName'))" class="wo-time-error">
                  <i class="ri-error-warning-line"></i> Process is required.
                </span>
                <span *ngIf="isFieldInvalid(getMachineRows(i).at(j).get('processstartTime'))" class="wo-time-error">
                  <i class="ri-error-warning-line"></i> Process start time is required.
                </span>
                <span *ngIf="isFieldInvalid(getMachineRows(i).at(j).get('processendTime'))" class="wo-time-error">
                  <i class="ri-error-warning-line"></i> Process end time is required.
                </span>
                <span *ngFor="let err of getTimeErrors(i, j); trackBy: trackByIndex" class="wo-time-error">
                  <i class="ri-error-warning-line"></i> {{ err }}
                </span>
                <span *ngIf="isFieldInvalid(getMachineRows(i).at(j).get('plannedQty'))" class="wo-time-error">
                  <i class="ri-error-warning-line"></i> Planned qty must be at least 1.
                </span>
                <span *ngIf="isQtyExceedsCapacity(i, j)" class="wo-time-error">
                  <i class="ri-error-warning-line"></i> Planned qty cannot exceed capacity ({{ getRowCapacity(i, j) }}).
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button type="button" class="wo-add-btn" (click)="addBatch()">
        <i class="ri-add-line"></i> Add Batch
      </button>
    </form>
  </div>
  <div class="wo-modal-footer">
    <button class="wo-btn-cancel" (click)="modal.dismiss()">Cancel</button>
    <button class="wo-btn-save" (click)="saveWorkOrder(modal)">
      <i class="ri-save-line"></i>
      {{ isEditMode ? (editingCard?.col === 'todo' || editingCard?.col === 'planning' ? 'Update Work Order' : 'Save NewBatch') : 'Save Work Order' }}
    </button>
  </div>
</ng-template>